import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../../queryKeys";
import { ClassEventService } from "../../../services/class-event.service";
import { TUpcomingClassEvent } from "../../../models/ClassEvent";

export const useGetUpcomingClassEventsReservationsQuery = () => {
  return useQuery<TUpcomingClassEvent[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_UPCOMING_CLASS_EVENTS_RESERVATIONS],
    queryFn: () => ClassEventService.getUpcomingClassEvents().then((res) => res.data),
  });
};
